/** Bellanio volume discount progress. */
(function () {
  'use strict';

  var TIERS = [
    { min: 2, pct: 0.10 },
    { min: 3, pct: 0.15 },
    { min: 4, pct: 0.20 }
  ];

  function money(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents);
    }
    return new Intl.NumberFormat('de-CH', {style: 'currency', currency: 'CHF'}).format(cents / 100);
  }

  function summarizeCart(cart) {
    var count = 0;
    var subtotal = 0;
    var items = (cart && cart.items) || [];
    items.forEach(function (item) {
      if (item.handle === 'shipping-protection') return;
      count += item.quantity;
      subtotal += (typeof item.original_line_price === 'number' && item.original_line_price > 0) ? item.original_line_price : item.final_line_price;
    });
    return { count: count, subtotal: subtotal };
  }

  function currentState(count, subtotal) {
    var next = null;
    var best = null;
    TIERS.forEach(function (tier) {
      if (count >= tier.min) {
        best = tier;
      } else if (!next && count < tier.min) {
        next = tier;
      }
    });

    var needed = next ? next.min - count : 0;
    return {
      count: count,
      subtotal: subtotal,
      next: next,
      best: best,
      needed: needed,
      savings: best ? Math.round(subtotal * best.pct) : 0
    };
  }

  var BellanioVolumeBar = class extends HTMLElement {
    connectedCallback() {
      this._onCartChanged = this._onCartChanged.bind(this);
      document.addEventListener('cart:change', this._onCartChanged);

      this._message = this.querySelector('[data-message]');
      this._badge = this.querySelector('[data-badge]');
      this._note = this.querySelector('[data-note]');
      this._chips = Array.prototype.slice.call(this.querySelectorAll('[data-min]'));

      this.render(+this.dataset.count || 0, +this.dataset.subtotal || 0);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this._onCartChanged);
    }

    _onCartChanged(event) {
      var summary = summarizeCart(event.detail.cart);
      this.dataset.count = summary.count;
      this.dataset.subtotal = summary.subtotal;
      this.render(summary.count, summary.subtotal);
    }

    render(count, subtotal) {
      if (!this._message) {
        return;
      }
      var state = currentState(count, subtotal);

      this._chips.forEach((chip) => {
        chip.classList.toggle('is-active', count >= +chip.getAttribute('data-min'));
      });

      if (state.best) {
        this._badge.hidden = false;
        this._badge.textContent = Math.round(state.best.pct * 100) + '% Rabatt';
        this._note.hidden = false;
        this._note.textContent = 'Sie sparen ca. ' + money(state.savings) + '.';
      } else {
        this._badge.hidden = true;
        this._note.hidden = true;
      }

      /* Meilenstein-Copy: Erreichen eines Stops soll sich gut anfuehlen. */
      var bestPct = state.best ? Math.round(state.best.pct * 100) : 0;
      var nextPct = state.next ? Math.round(state.next.pct * 100) : 0;

      if (state.best && state.next) {
        this._message.textContent = bestPct + '% Rabatt freigeschaltet. Mit ' + (state.needed === 1 ? 'einem weiteren Artikel' : state.needed + ' weiteren Artikeln') + ' erhalten Sie ' + nextPct + '% Rabatt.';
      } else if (state.best) {
        this._message.textContent = 'Sie haben 20% Rabatt auf Ihre Auswahl freigeschaltet.';
      } else {
        this._message.textContent = 'Fügen Sie noch ' + state.needed + ' Artikel hinzu und sichern Sie sich 10% Rabatt.';
      }

      /* Timeline: Fuellstand und Marker (2 Artikel -> Stop 1, 3 -> 2, 4+ -> 3). */
      var track = this.querySelector('.bn-vol__track');
      var marker = this.querySelector('.bn-vol__marker');
      if (track) {
        var progress = Math.min(1, Math.max(0, (count - 2) / 2));
        track.style.setProperty('--progress', String(progress));
      }
      if (marker) {
        marker.style.setProperty('--marker-opacity', state.best ? '1' : '0');
        marker.style.setProperty('--marker-scale', state.best ? '1' : '.6');
      }
    }
  };

  if (!window.customElements.get('bellanio-volume-bar')) {
    window.customElements.define('bellanio-volume-bar', BellanioVolumeBar);
  }
})();
